export enum UserRole {
  Admin = 'admin',
  User = 'user',
}

export type User = {
  userID: string;
  username: string;
  login: string;
  role: UserRole;
};

export type NewUser = Omit<User, 'userID'> & {
  password: string;
  confirmedPassword?: string;
};

export type ResetPassword = {
  userID: string;
  newPassword: string;
  login?: string;
  confirmedNewPassword?: string;
};

export type ChangePassword = ResetPassword & {
  oldPassword: string;
};

export type Credentials = {
  login: string;
  password: string;
  force?: boolean;
};

export type Token = {
  token: string;
};

export type ApiResponse<T> = {
  data: T;
};

export type LoginResponse = ApiResponse<Token>;

export type UserResponse = ApiResponse<User>;

export type UsersResponse = ApiResponse<User[]>;
